<template>
    <div class="rp-messenger-screen-conversations-list-content">
        <div class="rp-messenger-screen-conversations-list-content-scroller">
			<div class="rp-messenger-screen-conversations-list-content-container">
				<div class="rp-messenger-screen-conversations-list">
					<ConversationListItem
						v-for="(conversation, index) in conversations"
						:key="conversation.id"
						:conversation="conversation"
						:style="{ animationDuration: (index+1)*0.1 + 's' }"
						:class="{ 'animated slideInUp': index < 7 }"
						@click="$emit('onConversationClick', conversation)" />
				</div>
			</div>
		</div>
		<div class="rp-messenger-screen-conversations-list-footer">
			<StartConversationButton
				:label="$t('homeScreen.newMessageButton').replace('+', '')"
				@click="$emit('onNewConversationButtonClick')"/>
			
			<div class="rp-clc-footer">
				<PoweredBy
					class="rp-clc-powered-by" 
					:getPoweredByURL="getPoweredByURL" 
				/>
			</div>
		</div>
    </div>
</template>

<script>
import ConversationListItem from './ConversationListItem'
import StartConversationButton from './StartConversationButton'
import PoweredBy from '../shared/PoweredBy'

export default {
	components: {
		ConversationListItem,
		StartConversationButton,
		PoweredBy
	},
	props: {
		conversations: {
			type: Array,
			required: true
		},
		getPoweredByURL: {
			type: String,
		}
	}
}
</script>

<style lang="scss">

.rp-messenger-screen-conversations-list-content {
	flex: 1;
	display: flex;
	@include chromeBugFix;
}

.rp-messenger-screen-conversations-list-footer {
	@include absoluteFullXCenter;
	background: linear-gradient(0deg, white, rgba(255, 255, 255, 0));
	bottom: 0;

	.rp-start-conversation {
		margin: 0 auto 1.5rem;
	}
}

.rp-messenger-screen-conversations-list-content-scroller {
	flex: 1;
	overflow: auto;
	padding-bottom: 90px;
}

.rp-messenger-screen-conversations-list {
	.rp-messenger-conversation {
		padding: 1.25rem;
	}
}
.rp-clc-powered-by{
	border-top: 1px solid #eeeeee;
	border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
	font-size:12px;
	font-weight:500;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
    padding: 5px 0;
    background: #fff;
	.text{
		margin-right: 5px;
	}
}

</style>